/**
 * A helper function to set up a part/block by query
 * The class is used to set up all similar/duplicated parts/blocks. Id is to get a specific one.
 * @param {string} className The query name of the part
 * @param {Function} constructorFunction The function that returns the class of the part
 * @returns {Function} A function that can get the part by id
 */
const jsSetup = (query, constructorFunction) => {
	const elements = document.querySelectorAll(query)
	const classes = []
	for (let index = 0; index < elements.length; index++) classes.push(constructorFunction(elements[index].id))
	const getPart = (id) => {
		for (let index = 0; index < elements.length; index++) if (elements[index].id === id) return classes[index]
		return null
	}
	return getPart
}

//By class name
const jsSetupClasses = (className, constructorFunction) => {
	return jsSetup(`*[class^="${className}"]`, constructorFunction)
}
